import { render, staticRenderFns } from "./AccessibilityInApp.vue?vue&type=template&id=5698316f&scoped=true&"
import script from "./AccessibilityInApp.vue?vue&type=script&lang=js&"
export * from "./AccessibilityInApp.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityInApp.vue?vue&type=style&index=0&id=5698316f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5698316f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
